const { PermCameraMicRounded } = require("@material-ui/icons");

module.exports = {
  // BASE_URL: "http://localhost:5042/",
  // BASE_URL: "https://expense.corob.online/",
  BASE_URL: "http://corobexp.biztran.in/",
  //BASE_URL: "http://travel.corob.live/",
  //  REPORT_URL:"http://pscrm.rpt.biztran.in/WebService.asmx/PrintReport",
  // REPORT_URL: "http://localhost:49490/WebService.asmx/PrintReport",
  form_list: [
    // {
    //   name: "Travel Request Approvel",
    //   path: "/",
    //   icon: "Home",
    //   isMenuItem: 1,
    //   Authorization: ["Admin", "BA", "BA Head", "ISR", "Manager", "Business Analyst"],
    //   subMenu: [],
    // },
    {
      name: "Expenses",
      path: "/",
      icon: "Extension",
      isMenuItem: 1,
      Authorization: ["Admin", "BA", "BA Head", "ISR", "IS Head"],
      subMenu: [
        {
          name: "Home Page",
          path: "/Home",
          icon: "Home",
          isMenuItem: 1,
          Authorization: ["Admin", "BA", "BA Head", "ISR", "IS Head"],
        },
        {
          name: "Expense Sheet List",
          path: "/ExpenseSheetList",
          icon: "SalesOrderIcon",
          isMenuItem: 1,
          Authorization: ["Admin", "BA", "BA Head", "ISR", "IS Head"],
        },
      ],
    },

    {
      name: "Approvals",
      path: "/",
      icon: "Extension",
      isMenuItem: 1,
      Authorization: ["Manager", "CFO", "BA Head", "ISR", "IS Head","Admin"],
      subMenu: [
        {
          name: "Work Plan Approval",
          path: "/TravelRequestApproval",
          icon: "Home",
          isMenuItem: 1,
          Authorization: ["Manager", "CFO", "BA Head", "ISR", "IS Head","Admin"],
        },
        {
          name: "Expense Approval",
          path: "/ExpenseApproval",
          icon: "SalesOrderIcon",
          isMenuItem: 1,
          Authorization: ["Manager", "CFO", "BA Head", "ISR", "IS Head","Admin"],
        },

        {
          name: "Senior Expense Approval",
          path: "/SeniorExpenseApproval",
          icon: "SalesOrderIcon",
          isMenuItem: 1,
          Authorization: ["Manager", "Admin"],
        },
        {
          name: "CFO Approval",
          path: "/PendingManagerApproval",
          icon: "SalesOrderIcon",
          isMenuItem: 1,
          Authorization: ["CFO", "BA", "BA Head", "ISR", "IS Head"],
        },
      ],
    },

    {
      name: "Travel Request",
      path: "/",
      icon: "Extension",
      isMenuItem: 1,
      Authorization: ["Employee", "Manager", "CFO", "BA Head", "ISR", "IS Head"],
      subMenu: [
        {
          name: "Travel Request",
          path: "/TravelRequest",
          icon: "Home",
          isMenuItem: 1,
          Authorization: ["Employee", "Manager", "CFO", "BA Head", "ISR", "IS Head"],
        },

      ],
    },

    {
      name: "Reports",
      path: "/crm/Reports",
      icon: "Extension",
      isMenuItem: 1,
      Authorization: ["Admin","Employee", "Manager", "BA Head", "BA", "IS Head", "ISR"],
      subMenu: [
        {
          name: "Work Plan Report",
          path: "/TravelRequestReport",
          icon: "StockLedgerIcon",
          isMenuItem: 1,
          Authorization: ["Admin", "BA", "BA Head", "ISR", "IS Head"],
        },
        {
          name: "Expense Claimed Report",
          path: "/ExpenseClaimedReport",
          icon: "StockLedgerIcon",
          isMenuItem: 1,
          Authorization: ["Admin", "BA", "BA Head", "ISR", "IS Head"],
        },
        {
          name: "Expense Report",
          path: "/ExpenseReport",
          icon: "SalesOrderIcon",
          isMenuItem: 1,
          Authorization: ["Admin","Employee", "Manager", "BA", "BA Head", "ISR", "IS Head"],
        },
        {
          name: "Senior Account Report",
          path: "/SeniorAccountReport",
          icon: "SalesOrderIcon",
          isMenuItem: 1,
          Authorization: ["Admin","Manager"],
        },
        {
          name: "Senior Expense Report",
          path: "/SeniorExpenseReport",
          icon: "SalesOrderIcon",
          isMenuItem: 1,
          Authorization: ["Admin","Manager"],
        },
        
        // {
        //   name: "Service Center",
        //   path: "/ServiceCenter/ServiceCenter",
        //   icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
        //   isMenuItem: 1,
        //   Authorization: ["Admin", "Manager", "Executive"],
        // },
        // {
        //   name: "Product Master",
        //   path: "/lead",
        //   icon: "AccountBoxSmall",
        //   isMenuItem: 1,
        //   Authorization: ["Admin", "BA", "BA Head", "Manager", "Business Analyst"],
        // },
        // {
        //   name: "Spare Master",
        //   path: "/AccountBoxSmall",
        //   icon: "AccountBoxSmall",
        //   isMenuItem: 1,
        //   Authorization: ["Admin", "BA", "BA Head", "ISR", "IS Head", "Manager"],
        // },
        // {
        //   name: "Symtom Master",
        //   path: "/Mylead",
        //   icon: "AccountBoxSmall",
        //   isMenuItem: 1,
        //   Authorization: ["Admin", "BA", "BA Head", "ISR", "IS Head", "Manager"],
        // },
        // {
        //   name: "Reason Master",
        //   path: "/AllocateLeadsToISR",
        //   icon: "AccountBoxSmall",
        //   isMenuItem: 1,
        //   Authorization: ["Admin", "BA", "BA Head"],
        // },
        // {
        //   name: "Defect Master",
        //   path: "/AssignLeadToSalesExecutive",
        //   icon: "AccountBoxSmall",
        //   isMenuItem: 1,
        //   Authorization: ["Admin", "BA", "BA Head", "ISR"],
        // },
        // {
        //   name: "Repair Master",
        //   path: "",
        //   icon: "AccountBoxSmall",
        //   isMenuItem: 1,
        //   Authorization: ["Admin", "BA", "BA Head", "ISR"],
        // },

        // {
        //   name: "States Master",
        //   path: "/",
        //   icon: "AccountBoxSmall",
        //   isMenuItem: 1,
        //   Authorization: ["Admin"],
        // },
        // {
        //   name: "City/Area Master",
        //   path: "/",
        //   icon: "AccountBoxSmall",
        //   isMenuItem: 1,
        //   Authorization: ["Admin", "Manager", "Executive"],
        // },
        // {
        //   name: "Primary Master",
        //   path: "/primarymaster/PrimaryMaster",
        //   icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
        //   isMenuItem: 1,
        //   Authorization: ["Admin", "BA", "BA Head", "IS Head", "ISR", "Manager"],
        // },
        // {
        //   name: "User Master",
        //   path: "/",
        //   icon: "AccountBoxSmall",
        //   isMenuItem: 1,
        //   Authorization: ["Admin", "Manager", "Executive"],
        // },

      ],
    },
    // {
    //   name: "Dashboard BA",
    //   path: "/DashboardBA",
    //   icon: "Home",//CRM Sales Dashboard Icon
    //   isMenuItem: 1,
    //   Authorization: ["Admin", "BA", "BA Head","Manager", "Business Analyst"],
    // },       
    // {
    //   name: "Dashboard IS",
    //   path: "/DashboardIS",
    //   icon: "Home",//CRM Sales Dashboard Icon
    //   isMenuItem: 1,
    //   Authorization: ["Admin", "IS Head","ISR","Manager"],
    // },
    //  {
    //   name: "Primary Master",
    //   path: "/primarymaster/PrimaryMaster",
    //   icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
    //   isMenuItem: 1,
    //   Authorization: ["Admin", "BA", "BA Head", "IS Head", "ISR", "Manager"],
    // },
    // {
    //   name: "Supplier Master",
    //   path: "/lead",
    //   icon: "AccountBoxSmall",
    //   isMenuItem: 1,
    //   Authorization: ["Admin", "BA", "BA Head", "ISR", "IS Head", "Manager"],
    // },


    // {
    //   name: "Service Center",
    //   path: "/DashboardSales",
    //   icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
    //   isMenuItem: 1,
    //   Authorization: ["Admin", "Manager", "Executive"],
    // },
    // {
    //   name: "Product Type",
    //   path: "/DashboardPreSales",
    //   icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
    //   isMenuItem: 1,
    //   Authorization: ["Admin", "Manager", "Executive"],
    // },


    // {
    //   name: "Product Categpry",
    //   path: "/ImportDataPoints",
    //   icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
    //   isMenuItem: 1,
    //   Authorization: ["Admin", "BA", "BA Head", "ISR", "Manager", "Business Analyst"],
    // },
    // {
    //   name: "Product Master",
    //   path: "/lead",
    //   icon: "AccountBoxSmall",
    //   isMenuItem: 1,
    //   Authorization: ["Admin", "BA", "BA Head", "Manager", "Business Analyst"],
    // },
    // {
    //   name: "Spare Master",
    //   path: "/AccountBoxSmall",
    //   icon: "AccountBoxSmall",
    //   isMenuItem: 1,
    //   Authorization: ["Admin", "BA", "BA Head", "ISR", "IS Head", "Manager"],
    // },
    // {
    //   name: "Symtom Master",
    //   path: "/Mylead",
    //   icon: "AccountBoxSmall",
    //   isMenuItem: 1,
    //   Authorization: ["Admin", "BA", "BA Head", "ISR", "IS Head", "Manager"],
    // },
    // {
    //   name: "Reason Master",
    //   path: "/AllocateLeadsToISR",
    //   icon: "AccountBoxSmall",
    //   isMenuItem: 1,
    //   Authorization: ["Admin", "BA", "BA Head"],
    // },
    // {
    //   name: "Defect Master",
    //   path: "/AssignLeadToSalesExecutive",
    //   icon: "AccountBoxSmall",
    //   isMenuItem: 1,
    //   Authorization: ["Admin", "BA", "BA Head", "ISR"],
    // },
    // {
    //   name: "Repair Master",
    //   path: "/NurtureBasket",
    //   icon: "AccountBoxSmall",
    //   isMenuItem: 1,
    //   Authorization: ["Admin", "BA", "BA Head", "ISR"],
    // },

    // {
    //   name: "States Master",
    //   path: "/Opportunity",
    //   icon: "AccountBoxSmall",
    //   isMenuItem: 1,
    //   Authorization: ["Admin"],
    // },
    // {
    //   name: "City/Area Master",
    //   path: "/MyOpportunities",
    //   icon: "AccountBoxSmall",
    //   isMenuItem: 1,
    //   Authorization: ["Admin", "Manager", "Executive"],
    // },
    // {
    //   name: "User Master",
    //   path: "/quotation",
    //   icon: "AccountBoxSmall",
    //   isMenuItem: 1,
    //   Authorization: ["Admin", "Manager", "Executive"],
    // },
    // {
    //   name: "Help Desk",
    //   path: "/SalesOrder",
    //   icon: "AccountBoxSmall",
    //   isMenuItem: 1,
    //   Authorization: ["Admin", "Manager", "Executive"],
    // },
    // {
    //   name: "Parameter Configuration",
    //   path: "/ListPOCForApprovingAndScheduling",
    //   icon: "AccountBoxSmall",
    //   isMenuItem: 1,
    //   Authorization: ["Admin", "Manager", "Executive"],
    // },
    // {
    //   name: "Questionnaire Master",
    //   path: "/MyPOCs",
    //   icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
    //   isMenuItem: 1,
    //   Authorization: ["Admin", "Manager", "Executive"],
    // },
    // {
    //   name: "Service Charge",
    //   path: "/account",
    //   icon: "AccountBoxSmall",
    //   isMenuItem: 1,
    //   Authorization: ["Admin", "Manager", "Executive"],
    // },
    //   {
    //     name: "My Customer",
    //     path: "/MyCustomer",
    //     icon: "AccountBoxSmall",
    //     isMenuItem: 1,
    //     Authorization: ["Admin", "Manager", "Executive"],
    //   },
    //   {
    //     name: "Activities",
    //     path: "/activities",
    //     icon: "ActivityIcon",
    //     isMenuItem: 1,
    //     Authorization: ["Admin", "Manager", "Executive"],
    //   },
    //   {
    //     name: "Message Center",
    //     path: "/MessageCenter",
    //     icon: "CustomerCompaintIcon",
    //     isMenuItem: 1,
    //     Authorization: ["Admin", "Manager", "Executive"],
    //   },
    //   {
    //     name: "Sales Target vs Actual",
    //     path: "/SalesTargetvsActual",
    //     icon: "SalesTargetVsActualIcon",
    //     isMenuItem: 1,
    //     Authorization: ["Admin", "Manager", "Executive"],
    //   },
    //   {
    //     name: "Quotation Analysis",
    //     path: "/QuotationAnalysis",
    //     icon: "QuotationAnalysisIcon",
    //     isMenuItem: 1,
    //     Authorization: ["Admin", "Manager"],
    //   },
    //   {
    //     name: "Quotation Lost Analysis",
    //     path: "/QuotationLostAnalysis",
    //     icon: "QuotationLostAnalysisIcon",
    //     isMenuItem: 1,
    //     Authorization: ["Admin", "Manager"],
    //   },
    // ],
    //},
    {
      name: "Masters",
      path: "/MIS",
      icon: "Extension",
      isMenuItem: 1,
      Authorization: ["Admin", "BA", "BA Head", "ISR", "IS Head",],
      subMenu: [
        {
          name: "Employee",
          path: "/Employeemaster/EmployeeMaster",
          icon: "GroupWorkIcon",//CRM Sales Dashboard Icon
          isMenuItem: 1,
          Authorization: ["Admin", "BA", "BA Head", "ISR", "IS Head",],
        },
        {
          name: "Primary Masters",
          path: "/primarymaster",
          icon: "EventNoteSmall",//CRM Sales Dashboard Icon
          isMenuItem: 1,
          Authorization: ["Admin", "BA", "BA Head", "ISR", "IS Head",],
        },
        {
          name: "User Master",
          path: "/UserMaster",
          icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
          isMenuItem: 1,
          Authorization: ["Admin", "BA", "BA Head", "ISR", "IS Head",],
        },
        // {
        //   name: "Call Updation",
        //   path: "/QuotationAnalysis",
        //   icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
        //   isMenuItem: 1,
        //   Authorization: ["Admin", "BA", "BA Head", "ISR", "IS Head",],
        // },
        // {
        //   name: "Customer Receipt",
        //   path: "/QuotationAnalysis",
        //   icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
        //   isMenuItem: 1,
        //   Authorization: ["Admin", "BA", "BA Head", "ISR", "IS Head",],
        // },
        // {
        //   name: "Change Outstation Local",
        //   path: "/QuotationAnalysis",
        //   icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
        //   isMenuItem: 1,
        //   Authorization: ["Admin", "BA", "BA Head", "ISR", "IS Head",],
        // },
        // {
        //   name: "Wrong Call Allocation SC",
        //   path: "/QuotationAnalysis",
        //   icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
        //   isMenuItem: 1,
        //   Authorization: ["Admin", "BA", "BA Head", "ISR", "IS Head",],
        // },
        // {
        //   name: "Wrong Call Allocation",
        //   path: "/QuotationAnalysis",
        //   icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
        //   isMenuItem: 1,
        //   Authorization: ["Admin", "BA", "BA Head", "ISR", "IS Head",],
        // },
        // {
        //   name: "ASI Call Closure",
        //   path: "/QuotationAnalysis",
        //   icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
        //   isMenuItem: 1,
        //   Authorization: ["Admin", "BA", "BA Head", "ISR", "IS Head",],
        // },
        // {
        //   name: "Generate Customer Receipt",
        //   path: "/QuotationAnalysis",
        //   icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
        //   isMenuItem: 1,
        //   Authorization: ["Admin", "BA", "BA Head", "ISR", "IS Head",],
        // },
        // {
        //   name: "HO Call Closure",
        //   path: "/QuotationAnalysis",
        //   icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
        //   isMenuItem: 1,
        //   Authorization: ["Admin", "BA", "BA Head", "ISR", "IS Head",],
        // },
        // {
        //   name: "Call Validation",
        //   path: "/QuotationAnalysis",
        //   icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
        //   isMenuItem: 1,
        //   Authorization: ["Admin", "BA", "BA Head", "ISR", "IS Head",],
        // },
      ],
    },

    //New Menu
    // {
    //   name: "Reports",
    //   path: "/Operations",
    //   icon: "Extension",
    //   isMenuItem: 1,
    //   Authorization: ["Admin", "Manager", "Executive"],
    //   subMenu: [
    //     {
    //       name: "Reminder Summary",
    //       path: "/OperationsDashboard",
    //       icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
    //       isMenuItem: 1,
    //       Authorization: ["Admin", "Manager", "Executive"],
    //     },
    //     {
    //       name: "Call Report",
    //       path: "/RenewalFollow-up",
    //       icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
    //       isMenuItem: 1,
    //       Authorization: ["Admin", "Manager", "Executive"],
    //     },
    //     {
    //       name: "Call Report Part Pending",
    //       path: "/SalesOrderOperation",
    //       icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
    //       isMenuItem: 1,
    //       Authorization: ["Admin", "Manager", "Executive"],
    //     },
    //     {
    //       name: "DSR",
    //       path: "/ApproveSalesOrder",
    //       icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
    //       isMenuItem: 1,
    //       Authorization: ["Admin", "Manager", "Executive"],
    //     },
    //     {
    //       name: "Open Pending with Ageing",
    //       path: "/Contact",
    //       icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
    //       isMenuItem: 1,
    //       Authorization: ["Admin", "Manager", "Executive"],
    //     },
    //     {
    //       name: "Summary Response Time",
    //       path: "/CustomerDispute",
    //       icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
    //       isMenuItem: 1,
    //       Authorization: ["Admin", "Manager", "Executive"],
    //     },
    //     {
    //       name: "Summary TAT",
    //       path: "/ApproveRenewal",
    //       icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
    //       isMenuItem: 1,
    //       Authorization: ["Admin", "Manager", "Executive"],
    //     },
    //     {
    //       name: "Area Allocation Report",
    //       path: "/Suspensions",
    //       icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
    //       isMenuItem: 1,
    //       Authorization: ["Admin", "Manager", "Executive"],
    //     },
    //     {
    //       name: "Closed Call Report",
    //       path: "/RenewalTargets",
    //       icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
    //       isMenuItem: 1,
    //       Authorization: ["Admin", "Manager", "Executive"],
    //     },
    //     {
    //       name: "Cancel Call Report",
    //       path: "/RenewalTargets",
    //       icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
    //       isMenuItem: 1,
    //       Authorization: ["Admin", "Manager", "Executive"],
    //     },
    //     {
    //       name: "Recieved SMS Log",
    //       path: "/RenewalTargets",
    //       icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
    //       isMenuItem: 1,
    //       Authorization: ["Admin", "Manager", "Executive"],
    //     },
    //     {
    //       name: "Call Closure Reconcile",
    //       path: "/RenewalTargets",
    //       icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
    //       isMenuItem: 1,
    //       Authorization: ["Admin", "Manager", "Executive"],
    //     },
    //     {
    //       name: "Part Consumption Report",
    //       path: "/RenewalTargets",
    //       icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
    //       isMenuItem: 1,
    //       Authorization: ["Admin", "Manager", "Executive"],
    //     },
    //     {
    //       name: "Duplicate Call Summary",
    //       path: "/RenewalTargets",
    //       icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
    //       isMenuItem: 1,
    //       Authorization: ["Admin", "Manager", "Executive"],
    //     },
    //     {
    //       name: "Defective-Inward Register",
    //       path: "/RenewalTargets",
    //       icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
    //       isMenuItem: 1,
    //       Authorization: ["Admin", "Manager", "Executive"],
    //     },
    //     {
    //       name: "Sales Register OK Stock",
    //       path: "/RenewalTargets",
    //       icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
    //       isMenuItem: 1,
    //       Authorization: ["Admin", "Manager", "Executive"],
    //     },
    //     {
    //       name: "Purchase Register OK Stock",
    //       path: "/RenewalTargets",
    //       icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
    //       isMenuItem: 1,
    //       Authorization: ["Admin", "Manager", "Executive"],
    //     },
    //     {
    //       name: "Customer Feedback",
    //       path: "/RenewalTargets",
    //       icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
    //       isMenuItem: 1,
    //       Authorization: ["Admin", "Manager", "Executive"],
    //     },

    //   ],
    // },
    // {
    //   name: "Print",
    //   path: "/Delivery",
    //   icon: "Extension",
    //   isMenuItem: 1,
    //   Authorization: ["Admin", "Manager", "Executive"],
    //   subMenu: [
    //     {
    //       name: "Job Card",
    //       path: "/DeliveryTeamDashboard",
    //       icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
    //       isMenuItem: 1,
    //       Authorization: ["Admin", "Manager", "Executive"],
    //     },
    //     {
    //       name: "Blank Job Card",
    //       path: "/OrderExecutive",
    //       icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
    //       isMenuItem: 1,
    //       Authorization: ["Admin", "Manager", "Executive"],
    //     },
    //   ],
    // },
    // {
    //   name: "Manufacturing",
    //   path: "/crmservice",
    //   icon: "Extension",
    //   isMenuItem: 1,
    //   Authorization: ["Admin", "Manager", "Executive"],
    //   subMenu: [
    //     {
    //       name: "MFG Batch",
    //       path: "/customer",
    //       icon: "CustomerCompaintIcon",
    //       isMenuItem: 1,
    //       Authorization: ["Admin", "Manager", "Executive"],
    //     },
    //     {
    //       name: "Approve MFG",
    //       path: "/customer",
    //       icon: "CustomerCompaintIcon",
    //       isMenuItem: 1,
    //       Authorization: ["Admin", "Manager", "Executive"],
    //     },

    //   ],
    // },
    // {
    //   name: "Receipts",
    //   path: "/Service",
    //   icon: "Extension",
    //   isMenuItem: 1,
    //   Authorization: ["Admin", "Manager", "Executive"],
    //   subMenu: [
    //     {
    //       name: "Good Receipts Note(Invoice)",
    //       path: "/SupportTickets",
    //       icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
    //       isMenuItem: 1,
    //       Authorization: ["Admin", "Manager", "Executive"],
    //     },
    //     {
    //       name: "Good Receipts Note(Transfer)",
    //       path: "/integrateSupportTickets",
    //       icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
    //       isMenuItem: 1,
    //       Authorization: ["Admin", "Manager", "Executive"],
    //     },
    //     {
    //       name: "ASC GRN",
    //       path: "/DeliveryApproval",
    //       icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
    //       isMenuItem: 1,
    //       Authorization: ["Admin", "Manager", "Executive"],
    //     },
    //     {
    //       name: "OK Spare Receipts",
    //       path: "/SuspensionApproval",
    //       icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
    //       isMenuItem: 1,
    //       Authorization: ["Admin", "Manager", "Executive"],
    //     },
    //     {
    //       name: "Defective Spare Receipts",
    //       path: "/SuspensionApproval",
    //       icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
    //       isMenuItem: 1,
    //       Authorization: ["Admin", "Manager", "Executive"],
    //     },
    //   ],
    // },
    // {
    //   name: "Inventory",
    //   path: "/Finance",
    //   icon: "Extension",
    //   isMenuItem: 1,
    //   Authorization: ["Admin", "Manager", "Executive"],
    //   subMenu: [
    //     {
    //       name: "Spare Purchase Entry",
    //       path: "/PurchaseOrder",
    //       icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
    //       isMenuItem: 1,
    //       Authorization: ["Admin", "Manager", "Executive"],
    //     },
    //     {
    //       name: "Invoice",
    //       path: "/PurchaseOrderFollow",
    //       icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
    //       isMenuItem: 1,
    //       Authorization: ["Admin", "Manager", "Executive"],
    //     },
    //     {
    //       name: "Transfer to ASC",
    //       path: "/ReleaseOrders",
    //       icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
    //       isMenuItem: 1,
    //       Authorization: ["Admin", "Manager", "Executive"],
    //     },
    //     {
    //       name: "Pending PO For Invoice",
    //       path: "/Invoices",
    //       icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
    //       isMenuItem: 1,
    //       Authorization: ["Admin", "Manager", "Executive"],
    //     },
    //     {
    //       name: "Generate Invoice/Transfer",
    //       path: "/IncomingPayments",
    //       icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
    //       isMenuItem: 1,
    //       Authorization: ["Admin", "Manager", "Executive"],
    //     },
    //     {
    //       name: "OK Spare Return",
    //       path: "/AROutstandingAndFollowup",
    //       icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
    //       isMenuItem: 1,
    //       Authorization: ["Admin", "Manager", "Executive"],
    //     },
    //     {
    //       name: "Defective Spare Transfer",
    //       path: "/AROutstandingAndFollowup",
    //       icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
    //       isMenuItem: 1,
    //       Authorization: ["Admin", "Manager", "Executive"],
    //     },
    //     {
    //       name: "Inter Branch Transfer-Out",
    //       path: "/AROutstandingAndFollowup",
    //       icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
    //       isMenuItem: 1,
    //       Authorization: ["Admin", "Manager", "Executive"],
    //     },
    //     {
    //       name: "Inter Branch Transfer-In(Add)",
    //       path: "/AROutstandingAndFollowup",
    //       icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
    //       isMenuItem: 1,
    //       Authorization: ["Admin", "Manager", "Executive"],
    //     },
    //     {
    //       name: "Inter Branch Transfer-In",
    //       path: "/AROutstandingAndFollowup",
    //       icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
    //       isMenuItem: 1,
    //       Authorization: ["Admin", "Manager", "Executive"],
    //     },
    //     {
    //       name: "Stock Status",
    //       path: "/AROutstandingAndFollowup",
    //       icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
    //       isMenuItem: 1,
    //       Authorization: ["Admin", "Manager", "Executive"],
    //     },
    //     {
    //       name: "Stock Ledger",
    //       path: "/AROutstandingAndFollowup",
    //       icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
    //       isMenuItem: 1,
    //       Authorization: ["Admin", "Manager", "Executive"],
    //     },


    //   ],
    // },

    // {
    //   name: "Purchase Order",
    //   path: "/sales",
    //   icon: "Build",
    //   isMenuItem: 1,
    //   Authorization: ["Admin", "Manager", "Executive"],
    //   subMenu: [
    //     {
    //       name: "Purchase Order Search",
    //       path: "/deliveryChallan",
    //       icon: "AccountBoxSmall",
    //       isMenuItem: 1,
    //       Authorization: ["Admin", "Manager", "Executive"],
    //     },
    //     {
    //       name: "Generate PO",
    //       path: "/dispatchManagement",
    //       icon: "AccountBoxSmall",
    //       isMenuItem: 1,
    //       Authorization: ["Admin", "Manager", "Executive"],
    //     },
    //   ],
    // },
    // {
    //   name: "Claim Processing",
    //   path: "/inventory",
    //   icon: "AccountBoxSmall",
    //   isMenuItem: 1,
    //   Authorization: ["Admin", "Manager"],
    //   subMenu: [
    //     {
    //       name: "View Validated Call",
    //       path: "/fginward",
    //       icon: "AccountBoxSmall",
    //       isMenuItem: 1,
    //       Authorization: ["Admin", "Manager"],
    //     },
    //     {
    //       name: "View Claim",
    //       path: "/stockIn",
    //       icon: "AccountBoxSmall",
    //       isMenuItem: 1,
    //       Authorization: ["Admin", "Manager"],
    //     },
    //     {
    //       name: "Auto Rejected Calls",
    //       path: "/stockOut",
    //       icon: "AccountBoxSmall",
    //       isMenuItem: 1,
    //       Authorization: ["Admin", "Manager"],
    //     },
    //     {
    //       name: "Claim Rejection",
    //       path: "/stockLedger",
    //       icon: "AccountBoxSmall",
    //       isMenuItem: 1,
    //       Authorization: ["Admin", "Manager"],
    //     },
    //     {
    //       name: "View Payment Details",
    //       path: "/stockStatus",
    //       icon: "AccountBoxSmall",
    //       isMenuItem: 1,
    //       Authorization: ["Admin", "Manager"],
    //     },
    //     {
    //       name: "Approve Bill",
    //       path: "/stockStatus",
    //       icon: "AccountBoxSmall",
    //       isMenuItem: 1,
    //       Authorization: ["Admin", "Manager"],
    //     },
    //   ],
    // },
    // //New Menu End
    // {
    //   name: "ASC Ledger",
    //   path: "/masters",
    //   icon: "EventNote",
    //   isMenuItem: 1,
    //   Authorization: ["Admin"],
    //   subMenu: [
    //     {
    //       name: "SD Ledger",
    //       path: "/product",
    //       icon: "FeaturedPlayListIconSmall",
    //       isMenuItem: 1,
    //       Authorization: ["Admin"],
    //     },
    //     {
    //       name: "Sales Ledger",
    //       path: "/user",
    //       icon: "AccountBoxSmall",
    //       isMenuItem: 1,
    //       Authorization: ["Admin"],
    //     },
    //     {
    //       name: "Out Warranty",
    //       path: "/DocTestListMaster",
    //       icon: "AccountBoxSmall",
    //       isMenuItem: 1,
    //       Authorization: ["Admin"],
    //     },
    //     {
    //       name: "Claim Ledger",
    //       path: "/primary",
    //       icon: "EventNoteSmall",
    //       isMenuItem: 1,
    //       Authorization: ["Admin"],
    //     },
    //   ],
    // },
    // {
    //   name: "Master",
    //   path: "/masters/primarymaster/PrimaryMaster",
    //   icon: "Extension",
    //   isMenuItem: 1,
    //   Authorization: ["Admin", "BA Head", "BA", "IS Head", "ISR", "Manager"],
    //   subMenu: []
    // },
    // {
    //   name: "TCR",
    //   path: "/TCR",
    //   icon: "Extension",
    //   isMenuItem: 1,
    //   Authorization: ["Admin"],
    //   subMenu: [],
    // },

    // {
    //   name: "Bulletin",
    //   path: "/Bulletin",
    //   icon: "Extension",
    //   isMenuItem: 1,
    //   Authorization: ["Admin"],
    //   subMenu: [],
    // },
    // {
    //   name: "Price List",
    //   path: "/Price List",
    //   icon: "Extension",
    //   isMenuItem: 1,
    //   Authorization: ["Admin"],
    //   subMenu: [],
    // },
    // {
    //   name: "Change Password",
    //   path: "/Change Password",
    //   icon: "Extension",
    //   isMenuItem: 1,
    //   Authorization: ["Admin"],
    //   subMenu: [],
    // },
    // {
    //   name: "Customer Management",
    //   path: "/masters",
    //   icon: "AccountBoxSmall",
    //   isMenuItem: 1,
    //   Authorization: ["Admin"],
    //   subMenu: [
    //     {
    //       name: "Customer Data Management",
    //       path: "/product",
    //       icon: "AccountBoxSmall",
    //       isMenuItem: 1,
    //       Authorization: ["Admin"],
    //     },
    //     {
    //       name: "Product Registration",
    //       path: "/user",
    //       icon: "AccountBoxSmall",
    //       isMenuItem: 1,
    //       Authorization: ["Admin"],
    //     },
    //   ],
    // },

    // {
    //   name: "Account View",
    //   path: "/account/AccountView",
    //   isMenuItem: 0,
    //   Authorization: ["Admin", "BA", "BA Head", "ISR"],
    //   subMenu: [],
    // },
    // {
    //   name: "Service Center View",
    //   path: "/servicecenter/ServiceCenterView",
    //   isMenuItem: 0,
    //   Authorization: ["Admin", "BA", "BA Head", "ISR"],
    //   subMenu: [],
    // },
    // {
    //   name: "POC View",
    //   path: "/MyPOCs/POCView",
    //   isMenuItem: 0,
    //   Authorization: ["Admin", "Manager", "Executive", "BA", "BA Head"],
    //   subMenu: [],
    // },
    // {
    //   name: "Opportunity View",
    //   path: "/Opportunity/OpportunityView",
    //   isMenuItem: 0,
    //   Authorization: ["Admin", "BA", "BA Head", "ISR"],
    //   subMenu: [],
    // },
    // {
    //   name: "Quotation View",
    //   path: "/quotation/QuotationView",
    //   isMenuItem: 0,
    //   Authorization: ["Admin", "BA", "BA Head", "ISR"],
    //   subMenu: [],
    // },
    // {
    //   name: "Product View",
    //   path: "/product/ProductView",
    //   isMenuItem: 0,
    //   Authorization: ["Admin", "BA", "BA Head", "ISR"],
    //   subMenu: [],
    // },
    // {
    //   name: "Sales Order View",
    //   path: "/SalesOrder/SalesOrderView",
    //   isMenuItem: 0,
    //   Authorization: ["Admin", "BA", "BA Head", "ISR"],
    //   subMenu: [],
    // },
    // {
    //   name: "Delivery Challan View",
    //   path: "/deliveryChallan/DeliveryChallanView",
    //   isMenuItem: 0,
    //   Authorization: ["Admin", "BA", "BA Head", "ISR"],
    //   subMenu: [],
    // },
    // {
    //   name: "ImportDataPoints",
    //   path: "/lead/ImportDataPoints",
    //   isMenuItem: 0,
    //   Authorization: ["Admin", "BA", "BA Head", "ISR"],
    //   subMenu: [],
    // },
  ],
};
